<template>
  <div>
    <v-img
      class="grey lighten-3 mb-2"
      height="100"
      :aspect-ratio="16 / 9"
      :src="user.signature || require('@/assets/img/signature-placeholder.png')"
    ></v-img>
    <div style="width: 300px" class="text-center">
      <small class="text-mute"
        >Ensure your signature fits in the area provided above. 300x100</small
      >
    </div>

    <!-- Hidden input -->
    <input
      accept=".jpg,.png,.jpeg"
      type="file"
      ref="signatureInput"
      hidden
      @click="$event.target.value = ''"
      @change="processSignature"
    />
    <div class="text-center mt-0">
      <v-btn
        @click="$refs.signatureInput.click()"
        class="text-capitalize text-caption"
        color="primary"
        depressed
        >Upload Signature</v-btn
      >
      <v-btn
        @click="removeSignature"
        class="text-capitalize text-caption ml-2"
        depressed
        >Remove Signature</v-btn
      >
    </div>
  </div>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SharedMixin from '@/modules/shared/mixins/shared.mixin';

export default {
  mixins: [PageMixin, SharedMixin],
  data: () => {
    return {
      dialog: false,
      loading: false,
      signatureImg: null
    };
  },
  computed: {
    ...mapGetters('authModule', ['user', 'getUserSignature'])
  },
  watch: {
    dialog(val) {
      if (!val) this.resetData();
    }
  },
  methods: {
    ...mapMutations('authModule', ['SET_USER']),

    ...mapActions('userModule', [
      'fetchUser',
      'uploadSignature',
      'deleteSignature'
    ]),

    /**
     * Method used to remove the signature
     */
    async removeSignature() {
      // check if user exist
      if (!this.user) return;

      try {
        this.loading = true;
        await this.deleteSignature({ id: this.user.id });
        const user = await this.fetchUser(this.user.id);
        this.SET_USER(user);
        this.showSnack({
          color: 'success',
          title: `Signature removed`,
          message: 'The image was removed successfully'
        });
      } catch (error) {
        console.log(error);
        this.showSnack({
          color: 'error',
          title: `Failed to delete signature`,
          message: 'Please try again later'
        });
      } finally {
        this.loading = false;
      }
    },

    // function used to upload avatar
    async processSignature(e) {
      try {
        // validate file
        if (!e) return;
        const file = e.target.files?.[0];
        if (!file) return;

        // check if file is an image
        if (!file.type.match('image/*'))
          return this.showSnack({
            color: 'error',
            title: `Invalid image`,
            message: 'Only images can be uploaded'
          });

        // create form data to be sent
        let fd = new FormData();
        fd.append('file', file);

        // upload image
        await this.uploadSignature({ data: fd, id: this.user.id });

        // Get user
        const user = await this.fetchUser(this.user.id);
        this.SET_USER(user);

        this.showSnack({
          color: 'success',
          title: `Signature uploaded`,
          message: 'Your signature has been updated'
        });
      } catch (error) {
        this.showSnack({
          color: 'error',
          title: `Something went wrong`,
          message: 'Please try uploading the image again'
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
